import axios from "axios";
import { useQuery } from "react-query";

import { InvoiceAdjustmentReason } from "fe-shared-transactions/src/types";

const optionsMapper = ({
  reasonId,
  adjustmentReason,
}: InvoiceAdjustmentReason) => ({
  value: reasonId,
  label: adjustmentReason,
});

const getOptions = (reasons: InvoiceAdjustmentReason[]) => ({
  items: reasons.map(optionsMapper),
  labelsByValue: reasons.reduce((result, i) => {
    result[i.reasonId] = i.adjustmentReason;
    return result;
  }, {} as { [key: number]: string }),
});

const getAdjustmentReasons = () =>
  axios
    .get<InvoiceAdjustmentReason[]>("invoices/adjustmentReasons")
    .then((res) => getOptions(res.data));

const useInvoiceAdjustmentReasons = () =>
  useQuery("invoiceAdjustmentReasons", getAdjustmentReasons, {
    staleTime: Infinity,
  });

export default useInvoiceAdjustmentReasons;
